"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Heart API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.3.3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PcpsApi = exports.PcpsApiFactory = exports.PcpsApiFp = exports.PcpsApiAxiosParamCreator = exports.PatientsApi = exports.PatientsApiFactory = exports.PatientsApiFp = exports.PatientsApiAxiosParamCreator = exports.PartnersApi = exports.PartnersApiFactory = exports.PartnersApiFp = exports.PartnersApiAxiosParamCreator = exports.CallsApi = exports.CallsApiFactory = exports.CallsApiFp = exports.CallsApiAxiosParamCreator = exports.TimeZones = exports.PcpDetailsConfirmationStatus = exports.PcpTaskTypeEnum = exports.PatientTypesTEST = exports.PatientActivityStatusEnum = exports.PatientActivityActivityEnum = exports.OptOutPatientRequestReasonEnum = exports.NoteMethod = exports.ImportProcessedFileStatuses = exports.ImportInProgressFileStatuses = exports.GetSendResultsRequestsResponseBodyProblemEnum = exports.GetPatient200ResponseClinicalDataPatientConditionEnum = exports.GetPatient200ResponseCallSuggestedCallTypeEnum = exports.GetPatient200ResponseCallResumeCallDirectionEnum = exports.GetPatient200ResponseCallResumeCallTypeEnum = exports.GetPatient200ResponseCallNextCallStatusEnum = exports.GetPatient200ResponseGenderEnum = exports.GetPatient200ResponseOnboardingFlowEnum = exports.Gender = exports.FlowStatuses = exports.FlowStatus = exports.ConfirmationStatus = exports.CommunicationPreferencesOption = exports.CallTypes = exports.CallScripts = exports.CallScriptNames = exports.CallPerformedRequestCallDirectionEnum = exports.CallPerformedRequestCallTypeEnum = exports.CallPerformedRequestOutcomeEnum = exports.CallDirections = exports.ActivityTypesSUPPORTTICKET = exports.ActivityTypes = exports.ActivityStatuses = exports.ActivityIcons = void 0;
exports.TagsApi = exports.TagsApiFactory = exports.TagsApiFp = exports.TagsApiAxiosParamCreator = exports.SendResultsApi = exports.SendResultsApiFactory = exports.SendResultsApiFp = exports.SendResultsApiAxiosParamCreator = void 0;
var globalAxios = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
exports.ActivityIcons = {
    Email: 'email',
    UserCheck: 'user-check',
    ClipboardNotes: 'clipboard-notes',
    MinutefulKit: 'minuteful-kit',
    Stethoscope: 'stethoscope',
    Support: 'support',
    PhoneIncoming: 'phone-incoming',
    PhoneOutgoing: 'phone-outgoing',
    Mailbox: 'mailbox',
    Sms: 'sms',
    StickyNote: 'sticky-note'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ActivityStatuses = {
    Pending: 'pending',
    Sent: 'sent',
    Opened: 'opened',
    Canceled: 'canceled',
    Rejected: 'rejected',
    Delayed: 'delayed',
    Arrived: 'arrived',
    Accepted: 'accepted',
    Answered: 'answered',
    NotAnswered: 'notAnswered',
    NotAnsweredVoicemailLeft: 'notAnsweredVoicemailLeft',
    Unreachable: 'unreachable',
    Completed: 'completed',
    Error: 'error',
    Scheduled: 'scheduled',
    PatientVerified: 'patientVerified',
    PendingPatientVerification: 'pendingPatientVerification',
    Resolved: 'resolved',
    Delivered: 'delivered',
    WrongAddress: 'wrongAddress',
    Refused: 'refused',
    Success: 'success',
    Clicked: 'clicked',
    Unsubscribed: 'unsubscribed'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ActivityTypes = {
    Email: 'email',
    Letter: 'letter',
    OutgoingSms: 'outgoingSms',
    IncomingSms: 'incomingSms',
    OutgoingCall: 'outgoingCall',
    IncomingCall: 'incomingCall',
    PushNotification: 'pushNotification',
    TestResult: 'testResult',
    KitShipment: 'kitShipment',
    Note: 'note',
    Prioritized: 'prioritized',
    AppVerification: 'appVerification',
    SupportTicket: 'supportTicket',
    PcpNameConfirmation: 'pcpNameConfirmation',
    PcpNpiConfirmation: 'pcpNpiConfirmation',
    PcpFaxConfirmation: 'pcpFaxConfirmation',
    ResultsDeliveryToDoctor: 'resultsDeliveryToDoctor'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ActivityTypesSUPPORTTICKET = {
    SupportTicket: 'supportTicket'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CallDirections = {
    Outgoing: 'outgoing',
    Incoming: 'incoming'
};
exports.CallPerformedRequestOutcomeEnum = {
    Consented: 'consented',
    SupportCompleted: 'supportCompleted',
    ReminderCompleted: 'reminderCompleted',
    CallLater: 'callLater',
    Indeterminate: 'indeterminate',
    VoicemailLeft: 'voicemailLeft',
    NoVoicemailLeft: 'noVoicemailLeft',
    UnreachableAnswered: 'unreachableAnswered',
    UnreachableUnanswered: 'unreachableUnanswered',
    Ineligible: 'ineligible',
    Declined: 'declined',
    DoNotCall: 'doNotCall',
    NoteOnly: 'noteOnly',
    PcpConfirmationCompleted: 'pcpConfirmationCompleted',
    TestFailedCompleted: 'testFailedCompleted',
    PostTestCompleted: 'postTestCompleted',
    IncompleteCall: 'incompleteCall'
};
exports.CallPerformedRequestCallTypeEnum = {
    Consent: 'consent',
    Support: 'support',
    Reminder: 'reminder',
    PcpConfirmation: 'pcpConfirmation',
    TestFailed: 'testFailed',
    PostTest: 'postTest'
};
exports.CallPerformedRequestCallDirectionEnum = {
    Incoming: 'incoming',
    Outgoing: 'outgoing'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CallScriptNames = {
    ConsentCallFirstUs: 'consent-call-first-us',
    ConsentKitFirstUnited: 'consent-kit-first-united',
    ConsentKitFirstUs: 'consent-kit-first-us',
    ConsentUk: 'consent-uk',
    FaxConfirmationUs: 'fax-confirmation-us',
    OnlineKitRequestUs: 'online-kit-request-us',
    PcpConfirmationUs: 'pcp-confirmation-us',
    ReminderUk: 'reminder-uk',
    ReminderUs: 'reminder-us',
    SupportUk: 'support-uk',
    SupportUs: 'support-us',
    TestFailedUs: 'test-failed-us',
    TestFailedUk: 'test-failed-uk',
    ConsentKitFirstUsOptumUc1: 'consent-kit-first-us-optum-uc1',
    ConsentKitFirstUsOptumUc2: 'consent-kit-first-us-optum-uc2',
    ConsentCallFirstUsOptum: 'consent-call-first-us-optum',
    PcpConfirmationUsOptum: 'pcp-confirmation-us-optum',
    ReminderUsOptumUc1: 'reminder-us-optum-uc1',
    ReminderUsOptumUc2: 'reminder-us-optum-uc2',
    SupportUsOptum: 'support-us-optum',
    TestFailedUsOptum: 'test-failed-us-optum',
    PostTestUsOptumUc1: 'post-test-us-optum-uc1',
    PostTestUsOptumUc2: 'post-test-us-optum-uc2',
    PostTestUs: 'post-test-us',
    PostTestUsGeisinger: 'post-test-us-geisinger'
};
/**
 * Call script name
 * @export
 * @enum {string}
 */
exports.CallScripts = {
    ConsentCallFirstUs: 'consent-call-first-us',
    ConsentKitFirstUnited: 'consent-kit-first-united',
    ConsentKitFirstUs: 'consent-kit-first-us',
    ConsentUk: 'consent-uk',
    OnlineKitRequestUs: 'online-kit-request-us',
    PcpConfirmationUs: 'pcp-confirmation-us',
    ReminderUk: 'reminder-uk',
    ReminderUs: 'reminder-us',
    SupportUk: 'support-uk',
    SupportUs: 'support-us',
    TestFailedUs: 'test-failed-us',
    TestFailedUk: 'test-failed-uk',
    ConsentKitFirstUsOptumUc1: 'consent-kit-first-us-optum-uc1',
    ConsentKitFirstUsOptumUc2: 'consent-kit-first-us-optum-uc2',
    ConsentCallFirstUsOptum: 'consent-call-first-us-optum',
    PcpConfirmationUsOptum: 'pcp-confirmation-us-optum',
    ReminderUsOptumUc1: 'reminder-us-optum-uc1',
    ReminderUsOptumUc2: 'reminder-us-optum-uc2',
    SupportUsOptum: 'support-us-optum',
    TestFailedUsOptum: 'test-failed-us-optum',
    PostTestUsOptumUc1: 'post-test-us-optum-uc1',
    PostTestUsOptumUc2: 'post-test-us-optum-uc2',
    PostTestUs: 'post-test-us',
    PostTestUsGeisinger: 'post-test-us-geisinger'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CallTypes = {
    Consent: 'consent',
    Support: 'support',
    Reminder: 'reminder',
    PcpConfirmation: 'pcpConfirmation',
    TestFailed: 'testFailed',
    PostTest: 'postTest'
};
/**
 * The type of the communication preference option.
 * @export
 * @enum {string}
 */
exports.CommunicationPreferencesOption = {
    Default: 'default',
    Allowed: 'allowed',
    Denied: 'denied'
};
/**
 * Confirmation status
 * @export
 * @enum {string}
 */
exports.ConfirmationStatus = {
    Pending: 'pending',
    Confirmed: 'confirmed',
    Unconfirmed: 'unconfirmed',
    OptOut: 'optOut',
    NoPcp: 'noPcp'
};
/**
 * The possible patient\'s flow statuses
 * @export
 * @enum {string}
 */
exports.FlowStatus = {
    PendingOnboarding: 'pendingOnboarding',
    PendingConsent: 'pendingConsent',
    Consented: 'consented',
    PendingTest: 'pendingTest',
    TestFailed: 'testFailed',
    OptedOut: 'optedOut',
    TestCompleted: 'testCompleted',
    CoolingOff: 'coolingOff',
    PendingFollowUpTest: 'pendingFollowUpTest',
    PendingPreApproval: 'pendingPreApproval',
    Declined: 'declined',
    Ineligible: 'ineligible',
    Unauthorized: 'unauthorized',
    PendingServiceQualification: 'pendingServiceQualification'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.FlowStatuses = {
    PendingOnboarding: 'pendingOnboarding',
    PendingConsent: 'pendingConsent',
    Consented: 'consented',
    PendingTest: 'pendingTest',
    TestFailed: 'testFailed',
    OptedOut: 'optedOut',
    TestCompleted: 'testCompleted',
    CoolingOff: 'coolingOff',
    PendingFollowUpTest: 'pendingFollowUpTest',
    PendingPreApproval: 'pendingPreApproval',
    Declined: 'declined',
    Ineligible: 'ineligible',
    Unauthorized: 'unauthorized',
    PendingServiceQualification: 'pendingServiceQualification'
};
/**
 * The patient\'s gender
 * @export
 * @enum {string}
 */
exports.Gender = {
    Male: 'male',
    Female: 'female',
    Other: 'other'
};
exports.GetPatient200ResponseOnboardingFlowEnum = {
    KitFirst: 'kitFirst',
    CallFirst: 'callFirst',
    MissingData: 'missingData'
};
exports.GetPatient200ResponseGenderEnum = {
    Male: 'male',
    Female: 'female',
    Other: 'other'
};
exports.GetPatient200ResponseCallNextCallStatusEnum = {
    Rejected: 'rejected',
    Delayed: 'delayed'
};
exports.GetPatient200ResponseCallResumeCallTypeEnum = {
    Support: 'support',
    Consent: 'consent',
    Reminder: 'reminder',
    PcpConfirmation: 'pcpConfirmation',
    TestFailed: 'testFailed',
    PostTest: 'postTest'
};
exports.GetPatient200ResponseCallResumeCallDirectionEnum = {
    Outgoing: 'outgoing',
    Incoming: 'incoming'
};
exports.GetPatient200ResponseCallSuggestedCallTypeEnum = {
    Support: 'support',
    Consent: 'consent',
    Reminder: 'reminder',
    PcpConfirmation: 'pcpConfirmation',
    TestFailed: 'testFailed',
    PostTest: 'postTest'
};
exports.GetPatient200ResponseClinicalDataPatientConditionEnum = {
    Diabetes: 'diabetes',
    Hypertension: 'hypertension',
    KidneyStones: 'kidneyStones',
    BmiOver30: 'bmiOver30',
    CkdFamilyHistory: 'ckdFamilyHistory',
    Ckd: 'ckd'
};
exports.GetSendResultsRequestsResponseBodyProblemEnum = {
    NoOrders: 'no orders',
    OrdersBlocked: 'orders blocked',
    PendingManualInspection: 'pending manual inspection'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ImportInProgressFileStatuses = {
    Pending: 'pending',
    FileValidated: 'fileValidated',
    EntriesValidated: 'entriesValidated'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ImportProcessedFileStatuses = {
    Failed: 'failed',
    Success: 'success'
};
/**
 * The method in which the note was received
 * @export
 * @enum {string}
 */
exports.NoteMethod = {
    Sms: 'sms',
    Email: 'email',
    Call: 'call',
    Chat: 'chat',
    System: 'system',
    Feedback: 'feedback',
    Complaints: 'complaints',
    AppReview: 'appReview',
    Other: 'other',
    Kit: 'kit'
};
exports.OptOutPatientRequestReasonEnum = {
    Declined: 'declined',
    Ineligible: 'ineligible'
};
exports.PatientActivityActivityEnum = {
    Email: 'email',
    Letter: 'letter',
    OutgoingSms: 'outgoingSms',
    IncomingSms: 'incomingSms',
    OutgoingCall: 'outgoingCall',
    IncomingCall: 'incomingCall',
    TestResult: 'testResult',
    KitShipment: 'kitShipment',
    Note: 'note',
    Prioritized: 'prioritized',
    PushNotification: 'pushNotification',
    AppVerification: 'appVerification',
    PcpNameConfirmation: 'pcpNameConfirmation',
    PcpNpiConfirmation: 'pcpNpiConfirmation',
    PcpFaxConfirmation: 'pcpFaxConfirmation'
};
exports.PatientActivityStatusEnum = {
    Pending: 'pending',
    Sent: 'sent',
    Opened: 'opened',
    Canceled: 'canceled',
    Rejected: 'rejected',
    Delayed: 'delayed',
    Arrived: 'arrived',
    Accepted: 'accepted',
    Answered: 'answered',
    NotAnswered: 'notAnswered',
    NotAnsweredVoicemailLeft: 'notAnsweredVoicemailLeft',
    Unreachable: 'unreachable',
    Completed: 'completed',
    Error: 'error',
    Scheduled: 'scheduled',
    PatientVerified: 'patientVerified',
    PendingPatientVerification: 'pendingPatientVerification',
    Resolved: 'resolved',
    Delivered: 'delivered',
    WrongAddress: 'wrongAddress',
    Refused: 'refused'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.PatientTypesTEST = {
    Test: 'test'
};
exports.PcpTaskTypeEnum = {
    Npi: 'npi',
    Fax: 'fax'
};
/**
 * Confirmation status for specific details like NPI or fax number
 * @export
 * @enum {string}
 */
exports.PcpDetailsConfirmationStatus = {
    Pending: 'pending',
    Confirmed: 'confirmed',
    Unconfirmed: 'unconfirmed',
    Needed: 'needed',
    Unresolved: 'unresolved'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.TimeZones = {
    AsiaJerusalem: 'Asia/Jerusalem',
    EuropeLondon: 'Europe/London',
    AmericaNewYork: 'America/New_York',
    AmericaDenver: 'America/Denver',
    AmericaAnchorage: 'America/Anchorage',
    AmericaPhoenix: 'America/Phoenix',
    AmericaChicago: 'America/Chicago',
    AmericaLosAngeles: 'America/Los_Angeles',
    PacificHonolulu: 'Pacific/Honolulu',
    AmericaBoise: 'America/Boise',
    AmericaIndianapolis: 'America/Indianapolis',
    AmericaDetroit: 'America/Detroit',
    AmericaSantoDomingo: 'America/Santo_Domingo',
    EtcUtc: 'Etc/UTC'
};
/**
 * CallsApi - axios parameter creator
 * @export
 */
var CallsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Call performed
         * @summary Call performed
         * @param {string} callId The call uuid
         * @param {CallPerformedRequest} callPerformedRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callPerformed: function (callId, callPerformedRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'callId' is not null or undefined
                            (0, common_1.assertParamExists)('callPerformed', 'callId', callId);
                            // verify required parameter 'callPerformedRequest' is not null or undefined
                            (0, common_1.assertParamExists)('callPerformed', 'callPerformedRequest', callPerformedRequest);
                            localVarPath = "/calls/{callId}/performed"
                                .replace("{".concat("callId", "}"), encodeURIComponent(String(callId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication umAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication umAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = callPerformedRequest;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.CallsApiAxiosParamCreator = CallsApiAxiosParamCreator;
/**
 * CallsApi - functional programming interface
 * @export
 */
var CallsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CallsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Call performed
         * @summary Call performed
         * @param {string} callId The call uuid
         * @param {CallPerformedRequest} callPerformedRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callPerformed: function (callId, callPerformedRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.callPerformed(callId, callPerformedRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, globalAxios, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CallsApiFp = CallsApiFp;
/**
 * CallsApi - factory interface
 * @export
 */
var CallsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CallsApiFp)(configuration);
    return {
        /**
         * Call performed
         * @summary Call performed
         * @param {string} callId The call uuid
         * @param {CallPerformedRequest} callPerformedRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        callPerformed: function (callId, callPerformedRequest, options) {
            return localVarFp.callPerformed(callId, callPerformedRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CallsApiFactory = CallsApiFactory;
/**
 * CallsApi - object-oriented interface
 * @export
 * @class CallsApi
 * @extends {BaseAPI}
 */
var CallsApi = /** @class */ (function (_super) {
    __extends(CallsApi, _super);
    function CallsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Call performed
     * @summary Call performed
     * @param {string} callId The call uuid
     * @param {CallPerformedRequest} callPerformedRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CallsApi
     */
    CallsApi.prototype.callPerformed = function (callId, callPerformedRequest, options) {
        var _this = this;
        return (0, exports.CallsApiFp)(this.configuration).callPerformed(callId, callPerformedRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CallsApi;
}(base_1.BaseAPI));
exports.CallsApi = CallsApi;
/**
 * PartnersApi - axios parameter creator
 * @export
 */
var PartnersApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create a new partner org unit
         * @summary Create a new partner org unit
         * @param {string} partnerName The partner name
         * @param {CreateOrgUnitRequest} createOrgUnitRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrgUnit: function (partnerName, createOrgUnitRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'partnerName' is not null or undefined
                            (0, common_1.assertParamExists)('createOrgUnit', 'partnerName', partnerName);
                            // verify required parameter 'createOrgUnitRequest' is not null or undefined
                            (0, common_1.assertParamExists)('createOrgUnit', 'createOrgUnitRequest', createOrgUnitRequest);
                            localVarPath = "/partners/{partnerName}/org-units"
                                .replace("{".concat("partnerName", "}"), encodeURIComponent(String(partnerName)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication umAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication umAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = createOrgUnitRequest;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} partnerName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInProgressFiles: function (partnerName, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'partnerName' is not null or undefined
                            (0, common_1.assertParamExists)('getInProgressFiles', 'partnerName', partnerName);
                            localVarPath = "/partners/{partnerName}/files/in-progress"
                                .replace("{".concat("partnerName", "}"), encodeURIComponent(String(partnerName)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication umAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication umAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get all the org units releated the partner
         * @summary Get org units
         * @param {string} partnerName The partner name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgUnits: function (partnerName, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'partnerName' is not null or undefined
                            (0, common_1.assertParamExists)('getOrgUnits', 'partnerName', partnerName);
                            localVarPath = "/partners/{partnerName}/org-units"
                                .replace("{".concat("partnerName", "}"), encodeURIComponent(String(partnerName)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication umAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication umAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} partnerName
         * @param {string} page The page to filter by. use to paginate results
         * @param {string} perPage The number of files each page will contain
         * @param {string} [filename] The filename to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessedFiles: function (partnerName, page, perPage, filename, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'partnerName' is not null or undefined
                            (0, common_1.assertParamExists)('getProcessedFiles', 'partnerName', partnerName);
                            // verify required parameter 'page' is not null or undefined
                            (0, common_1.assertParamExists)('getProcessedFiles', 'page', page);
                            // verify required parameter 'perPage' is not null or undefined
                            (0, common_1.assertParamExists)('getProcessedFiles', 'perPage', perPage);
                            localVarPath = "/partners/{partnerName}/files/processed"
                                .replace("{".concat("partnerName", "}"), encodeURIComponent(String(partnerName)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication umAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication umAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (perPage !== undefined) {
                                localVarQueryParameter['perPage'] = perPage;
                            }
                            if (filename !== undefined) {
                                localVarQueryParameter['filename'] = filename;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update Org unit
         * @summary Update org units
         * @param {string} partnerName The partner name
         * @param {string} orgUnitId The org unit id
         * @param {UpdateOrgUnitRequest} updateOrgUnitRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrgUnit: function (partnerName, orgUnitId, updateOrgUnitRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'partnerName' is not null or undefined
                            (0, common_1.assertParamExists)('updateOrgUnit', 'partnerName', partnerName);
                            // verify required parameter 'orgUnitId' is not null or undefined
                            (0, common_1.assertParamExists)('updateOrgUnit', 'orgUnitId', orgUnitId);
                            // verify required parameter 'updateOrgUnitRequest' is not null or undefined
                            (0, common_1.assertParamExists)('updateOrgUnit', 'updateOrgUnitRequest', updateOrgUnitRequest);
                            localVarPath = "/partners/{partnerName}/org-units/{orgUnitId}"
                                .replace("{".concat("partnerName", "}"), encodeURIComponent(String(partnerName)))
                                .replace("{".concat("orgUnitId", "}"), encodeURIComponent(String(orgUnitId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication umAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication umAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = updateOrgUnitRequest;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update partner
         * @summary Update partner
         * @param {string} partnerName The partner name
         * @param {UpdatePartnerRequest} updatePartnerRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePartner: function (partnerName, updatePartnerRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'partnerName' is not null or undefined
                            (0, common_1.assertParamExists)('updatePartner', 'partnerName', partnerName);
                            // verify required parameter 'updatePartnerRequest' is not null or undefined
                            (0, common_1.assertParamExists)('updatePartner', 'updatePartnerRequest', updatePartnerRequest);
                            localVarPath = "/partners/{partnerName}"
                                .replace("{".concat("partnerName", "}"), encodeURIComponent(String(partnerName)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication umAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication umAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = updatePartnerRequest;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.PartnersApiAxiosParamCreator = PartnersApiAxiosParamCreator;
/**
 * PartnersApi - functional programming interface
 * @export
 */
var PartnersApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PartnersApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create a new partner org unit
         * @summary Create a new partner org unit
         * @param {string} partnerName The partner name
         * @param {CreateOrgUnitRequest} createOrgUnitRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrgUnit: function (partnerName, createOrgUnitRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createOrgUnit(partnerName, createOrgUnitRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, globalAxios, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} partnerName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInProgressFiles: function (partnerName, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getInProgressFiles(partnerName, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, globalAxios, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get all the org units releated the partner
         * @summary Get org units
         * @param {string} partnerName The partner name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgUnits: function (partnerName, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getOrgUnits(partnerName, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, globalAxios, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} partnerName
         * @param {string} page The page to filter by. use to paginate results
         * @param {string} perPage The number of files each page will contain
         * @param {string} [filename] The filename to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessedFiles: function (partnerName, page, perPage, filename, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProcessedFiles(partnerName, page, perPage, filename, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, globalAxios, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update Org unit
         * @summary Update org units
         * @param {string} partnerName The partner name
         * @param {string} orgUnitId The org unit id
         * @param {UpdateOrgUnitRequest} updateOrgUnitRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrgUnit: function (partnerName, orgUnitId, updateOrgUnitRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateOrgUnit(partnerName, orgUnitId, updateOrgUnitRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, globalAxios, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update partner
         * @summary Update partner
         * @param {string} partnerName The partner name
         * @param {UpdatePartnerRequest} updatePartnerRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePartner: function (partnerName, updatePartnerRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updatePartner(partnerName, updatePartnerRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, globalAxios, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.PartnersApiFp = PartnersApiFp;
/**
 * PartnersApi - factory interface
 * @export
 */
var PartnersApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PartnersApiFp)(configuration);
    return {
        /**
         * Create a new partner org unit
         * @summary Create a new partner org unit
         * @param {string} partnerName The partner name
         * @param {CreateOrgUnitRequest} createOrgUnitRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrgUnit: function (partnerName, createOrgUnitRequest, options) {
            return localVarFp.createOrgUnit(partnerName, createOrgUnitRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} partnerName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInProgressFiles: function (partnerName, options) {
            return localVarFp.getInProgressFiles(partnerName, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all the org units releated the partner
         * @summary Get org units
         * @param {string} partnerName The partner name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgUnits: function (partnerName, options) {
            return localVarFp.getOrgUnits(partnerName, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} partnerName
         * @param {string} page The page to filter by. use to paginate results
         * @param {string} perPage The number of files each page will contain
         * @param {string} [filename] The filename to filter by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessedFiles: function (partnerName, page, perPage, filename, options) {
            return localVarFp.getProcessedFiles(partnerName, page, perPage, filename, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update Org unit
         * @summary Update org units
         * @param {string} partnerName The partner name
         * @param {string} orgUnitId The org unit id
         * @param {UpdateOrgUnitRequest} updateOrgUnitRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOrgUnit: function (partnerName, orgUnitId, updateOrgUnitRequest, options) {
            return localVarFp.updateOrgUnit(partnerName, orgUnitId, updateOrgUnitRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update partner
         * @summary Update partner
         * @param {string} partnerName The partner name
         * @param {UpdatePartnerRequest} updatePartnerRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePartner: function (partnerName, updatePartnerRequest, options) {
            return localVarFp.updatePartner(partnerName, updatePartnerRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PartnersApiFactory = PartnersApiFactory;
/**
 * PartnersApi - object-oriented interface
 * @export
 * @class PartnersApi
 * @extends {BaseAPI}
 */
var PartnersApi = /** @class */ (function (_super) {
    __extends(PartnersApi, _super);
    function PartnersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a new partner org unit
     * @summary Create a new partner org unit
     * @param {string} partnerName The partner name
     * @param {CreateOrgUnitRequest} createOrgUnitRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    PartnersApi.prototype.createOrgUnit = function (partnerName, createOrgUnitRequest, options) {
        var _this = this;
        return (0, exports.PartnersApiFp)(this.configuration).createOrgUnit(partnerName, createOrgUnitRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} partnerName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    PartnersApi.prototype.getInProgressFiles = function (partnerName, options) {
        var _this = this;
        return (0, exports.PartnersApiFp)(this.configuration).getInProgressFiles(partnerName, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all the org units releated the partner
     * @summary Get org units
     * @param {string} partnerName The partner name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    PartnersApi.prototype.getOrgUnits = function (partnerName, options) {
        var _this = this;
        return (0, exports.PartnersApiFp)(this.configuration).getOrgUnits(partnerName, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} partnerName
     * @param {string} page The page to filter by. use to paginate results
     * @param {string} perPage The number of files each page will contain
     * @param {string} [filename] The filename to filter by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    PartnersApi.prototype.getProcessedFiles = function (partnerName, page, perPage, filename, options) {
        var _this = this;
        return (0, exports.PartnersApiFp)(this.configuration).getProcessedFiles(partnerName, page, perPage, filename, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update Org unit
     * @summary Update org units
     * @param {string} partnerName The partner name
     * @param {string} orgUnitId The org unit id
     * @param {UpdateOrgUnitRequest} updateOrgUnitRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    PartnersApi.prototype.updateOrgUnit = function (partnerName, orgUnitId, updateOrgUnitRequest, options) {
        var _this = this;
        return (0, exports.PartnersApiFp)(this.configuration).updateOrgUnit(partnerName, orgUnitId, updateOrgUnitRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update partner
     * @summary Update partner
     * @param {string} partnerName The partner name
     * @param {UpdatePartnerRequest} updatePartnerRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartnersApi
     */
    PartnersApi.prototype.updatePartner = function (partnerName, updatePartnerRequest, options) {
        var _this = this;
        return (0, exports.PartnersApiFp)(this.configuration).updatePartner(partnerName, updatePartnerRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PartnersApi;
}(base_1.BaseAPI));
exports.PartnersApi = PartnersApi;
/**
 * PatientsApi - axios parameter creator
 * @export
 */
var PatientsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} patientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        abortPostTestFlow: function (patientId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'patientId' is not null or undefined
                            (0, common_1.assertParamExists)('abortPostTestFlow', 'patientId', patientId);
                            localVarPath = "/patients/{patientId}/abort-post-test-flow"
                                .replace("{".concat("patientId", "}"), encodeURIComponent(String(patientId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication umAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication umAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {CreatePatientRequestBody} createPatientRequestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatient: function (createPatientRequestBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createPatientRequestBody' is not null or undefined
                            (0, common_1.assertParamExists)('createPatient', 'createPatientRequestBody', createPatientRequestBody);
                            localVarPath = "/patients";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication umAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication umAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = createPatientRequestBody;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create a patient note
         * @summary Create a patient note
         * @param {string} patientId The patient uuid
         * @param {CreatePatientNoteRequest} createPatientNoteRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientNote: function (patientId, createPatientNoteRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'patientId' is not null or undefined
                            (0, common_1.assertParamExists)('createPatientNote', 'patientId', patientId);
                            // verify required parameter 'createPatientNoteRequest' is not null or undefined
                            (0, common_1.assertParamExists)('createPatientNote', 'createPatientNoteRequest', createPatientNoteRequest);
                            localVarPath = "/patients/{patientId}/notes"
                                .replace("{".concat("patientId", "}"), encodeURIComponent(String(patientId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication umAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication umAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = createPatientNoteRequest;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete tasks from scheduler and communications from behealthy and outreach
         * @summary Delete patients tasks and communications
         * @param {string} partnerName The partner name of the patients
         * @param {'sendKit' | 'scheduleCall' | 'sendSms' | 'sendEmail' | 'sendLetter' | 'sendPrioritizedOutreach' | 'endPatientService' | 'startPatientEndOfServiceCommunication' | 'startPatientEndOfFollowUpServiceCommunication'} method The event name of the task to delete
         * @param {string} [entityIds] The patient ids. Exactly one of the field must be given [cohortId, entityIds]
         * @param {string} [cohortId] The cohort id of the patients. Exactly one of the field must be given [cohortId, entityIds]
         * @param {string} [type] The type of the communication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePatientsTasks: function (partnerName, method, entityIds, cohortId, type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'partnerName' is not null or undefined
                            (0, common_1.assertParamExists)('deletePatientsTasks', 'partnerName', partnerName);
                            // verify required parameter 'method' is not null or undefined
                            (0, common_1.assertParamExists)('deletePatientsTasks', 'method', method);
                            localVarPath = "/patients/tasks";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication umAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication umAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (partnerName !== undefined) {
                                localVarQueryParameter['partnerName'] = partnerName;
                            }
                            if (entityIds !== undefined) {
                                localVarQueryParameter['entityIds'] = entityIds;
                            }
                            if (cohortId !== undefined) {
                                localVarQueryParameter['cohortId'] = cohortId;
                            }
                            if (method !== undefined) {
                                localVarQueryParameter['method'] = method;
                            }
                            if (type !== undefined) {
                                localVarQueryParameter['type'] = type;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get patient details
         * @summary Get patient details
         * @param {string} patientId The patient uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatient: function (patientId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'patientId' is not null or undefined
                            (0, common_1.assertParamExists)('getPatient', 'patientId', patientId);
                            localVarPath = "/patients/{patientId}"
                                .replace("{".concat("patientId", "}"), encodeURIComponent(String(patientId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication umAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication umAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} patientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientCycles: function (patientId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'patientId' is not null or undefined
                            (0, common_1.assertParamExists)('getPatientCycles', 'patientId', patientId);
                            localVarPath = "/patients/{patientId}/cycles"
                                .replace("{".concat("patientId", "}"), encodeURIComponent(String(patientId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication umAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication umAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} partnerName
         * @param {string} [q]
         * @param {FlowStatuses} [flowStatus]
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatients: function (partnerName, q, flowStatus, page, perPage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'partnerName' is not null or undefined
                            (0, common_1.assertParamExists)('getPatients', 'partnerName', partnerName);
                            localVarPath = "/patients";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication umAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication umAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (partnerName !== undefined) {
                                localVarQueryParameter['partnerName'] = partnerName;
                            }
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            if (flowStatus !== undefined) {
                                localVarQueryParameter['flowStatus'] = flowStatus;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (perPage !== undefined) {
                                localVarQueryParameter['perPage'] = perPage;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns a list of related patients
         * @summary Get the list of related patients
         * @param {string} patientId The patient uuid
         * @param {number} [page] the page to get
         * @param {number} [perPage] the number of entries per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedPatients: function (patientId, page, perPage, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'patientId' is not null or undefined
                            (0, common_1.assertParamExists)('getRelatedPatients', 'patientId', patientId);
                            localVarPath = "/patients/{patientId}/related-patients"
                                .replace("{".concat("patientId", "}"), encodeURIComponent(String(patientId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication umAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication umAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (perPage !== undefined) {
                                localVarQueryParameter['perPage'] = perPage;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Opt out the patient
         * @summary Opt out patient from service
         * @param {string} patientId The patient uuid
         * @param {OptOutPatientRequest} optOutPatientRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optOutPatient: function (patientId, optOutPatientRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'patientId' is not null or undefined
                            (0, common_1.assertParamExists)('optOutPatient', 'patientId', patientId);
                            // verify required parameter 'optOutPatientRequest' is not null or undefined
                            (0, common_1.assertParamExists)('optOutPatient', 'optOutPatientRequest', optOutPatientRequest);
                            localVarPath = "/patients/{patientId}/opt-out"
                                .replace("{".concat("patientId", "}"), encodeURIComponent(String(patientId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication umAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication umAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = optOutPatientRequest;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * schedule call to the patient with params
         * @summary schedule a call to patient
         * @param {string} patientId The patient uuid
         * @param {ScheduleCallRequest} scheduleCallRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleCall: function (patientId, scheduleCallRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'patientId' is not null or undefined
                            (0, common_1.assertParamExists)('scheduleCall', 'patientId', patientId);
                            // verify required parameter 'scheduleCallRequest' is not null or undefined
                            (0, common_1.assertParamExists)('scheduleCall', 'scheduleCallRequest', scheduleCallRequest);
                            localVarPath = "/patients/{patientId}/calls"
                                .replace("{".concat("patientId", "}"), encodeURIComponent(String(patientId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication umAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication umAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = scheduleCallRequest;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} outreachType
         * @param {string} partnerName
         * @param {File} file
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendBulkCommunications: function (outreachType, partnerName, file, type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'outreachType' is not null or undefined
                            (0, common_1.assertParamExists)('sendBulkCommunications', 'outreachType', outreachType);
                            // verify required parameter 'partnerName' is not null or undefined
                            (0, common_1.assertParamExists)('sendBulkCommunications', 'partnerName', partnerName);
                            // verify required parameter 'file' is not null or undefined
                            (0, common_1.assertParamExists)('sendBulkCommunications', 'file', file);
                            localVarPath = "/patients/send-communication";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
                            // authentication umAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication umAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (outreachType !== undefined) {
                                localVarFormParams.append('outreachType', outreachType);
                            }
                            if (partnerName !== undefined) {
                                localVarFormParams.append('partnerName', partnerName);
                            }
                            if (file !== undefined) {
                                localVarFormParams.append('file', file);
                            }
                            if (type !== undefined) {
                                localVarFormParams.append('type', type);
                            }
                            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = localVarFormParams;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Send a kit to the patient
         * @summary Send a kit to the patient
         * @param {string} patientId The patient uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendKit: function (patientId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'patientId' is not null or undefined
                            (0, common_1.assertParamExists)('sendKit', 'patientId', patientId);
                            localVarPath = "/patients/{patientId}/kits"
                                .replace("{".concat("patientId", "}"), encodeURIComponent(String(patientId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication umAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication umAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * send sms to the patient by sms type
         * @summary Send sms to patient
         * @param {string} patientId The patient uuid
         * @param {SendSmsRequest} sendSmsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSms: function (patientId, sendSmsRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'patientId' is not null or undefined
                            (0, common_1.assertParamExists)('sendSms', 'patientId', patientId);
                            // verify required parameter 'sendSmsRequest' is not null or undefined
                            (0, common_1.assertParamExists)('sendSms', 'sendSmsRequest', sendSmsRequest);
                            localVarPath = "/patients/{patientId}/smses"
                                .replace("{".concat("patientId", "}"), encodeURIComponent(String(patientId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication umAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication umAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = sendSmsRequest;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} patientId
         * @param {UpdatePatientConsentRequestDto} updatePatientConsentRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPatientConsents: function (patientId, updatePatientConsentRequestDto, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'patientId' is not null or undefined
                            (0, common_1.assertParamExists)('setPatientConsents', 'patientId', patientId);
                            // verify required parameter 'updatePatientConsentRequestDto' is not null or undefined
                            (0, common_1.assertParamExists)('setPatientConsents', 'updatePatientConsentRequestDto', updatePatientConsentRequestDto);
                            localVarPath = "/patients/{patientId}/consents"
                                .replace("{".concat("patientId", "}"), encodeURIComponent(String(patientId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication umAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication umAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = updatePatientConsentRequestDto;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @param {string} patientId
         * @param {PatientCallRequestBody} patientCallRequestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startCall: function (patientId, patientCallRequestBody, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'patientId' is not null or undefined
                            (0, common_1.assertParamExists)('startCall', 'patientId', patientId);
                            // verify required parameter 'patientCallRequestBody' is not null or undefined
                            (0, common_1.assertParamExists)('startCall', 'patientCallRequestBody', patientCallRequestBody);
                            localVarPath = "/patients/{patientId}/start-call"
                                .replace("{".concat("patientId", "}"), encodeURIComponent(String(patientId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication umAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication umAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = patientCallRequestBody;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * update patient
         * @summary Update a patient
         * @param {string} patientId The patient uuid
         * @param {UpdatePatientRequest} updatePatientRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatient: function (patientId, updatePatientRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'patientId' is not null or undefined
                            (0, common_1.assertParamExists)('updatePatient', 'patientId', patientId);
                            // verify required parameter 'updatePatientRequest' is not null or undefined
                            (0, common_1.assertParamExists)('updatePatient', 'updatePatientRequest', updatePatientRequest);
                            localVarPath = "/patients/{patientId}"
                                .replace("{".concat("patientId", "}"), encodeURIComponent(String(patientId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication umAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication umAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = updatePatientRequest;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Update pcp details
         * @summary Update the details for a patient\'s pcp
         * @param {string} patientId The patient uuid
         * @param {UpdatePcpDetailsRequest} updatePcpDetailsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePcpDetails: function (patientId, updatePcpDetailsRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'patientId' is not null or undefined
                            (0, common_1.assertParamExists)('updatePcpDetails', 'patientId', patientId);
                            // verify required parameter 'updatePcpDetailsRequest' is not null or undefined
                            (0, common_1.assertParamExists)('updatePcpDetails', 'updatePcpDetailsRequest', updatePcpDetailsRequest);
                            localVarPath = "/patients/{patientId}/pcp"
                                .replace("{".concat("patientId", "}"), encodeURIComponent(String(patientId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication umAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication umAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = updatePcpDetailsRequest;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.PatientsApiAxiosParamCreator = PatientsApiAxiosParamCreator;
/**
 * PatientsApi - functional programming interface
 * @export
 */
var PatientsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PatientsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} patientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        abortPostTestFlow: function (patientId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.abortPostTestFlow(patientId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, globalAxios, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {CreatePatientRequestBody} createPatientRequestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatient: function (createPatientRequestBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createPatient(createPatientRequestBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, globalAxios, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Create a patient note
         * @summary Create a patient note
         * @param {string} patientId The patient uuid
         * @param {CreatePatientNoteRequest} createPatientNoteRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientNote: function (patientId, createPatientNoteRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createPatientNote(patientId, createPatientNoteRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, globalAxios, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Delete tasks from scheduler and communications from behealthy and outreach
         * @summary Delete patients tasks and communications
         * @param {string} partnerName The partner name of the patients
         * @param {'sendKit' | 'scheduleCall' | 'sendSms' | 'sendEmail' | 'sendLetter' | 'sendPrioritizedOutreach' | 'endPatientService' | 'startPatientEndOfServiceCommunication' | 'startPatientEndOfFollowUpServiceCommunication'} method The event name of the task to delete
         * @param {string} [entityIds] The patient ids. Exactly one of the field must be given [cohortId, entityIds]
         * @param {string} [cohortId] The cohort id of the patients. Exactly one of the field must be given [cohortId, entityIds]
         * @param {string} [type] The type of the communication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePatientsTasks: function (partnerName, method, entityIds, cohortId, type, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deletePatientsTasks(partnerName, method, entityIds, cohortId, type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, globalAxios, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Get patient details
         * @summary Get patient details
         * @param {string} patientId The patient uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatient: function (patientId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPatient(patientId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, globalAxios, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} patientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientCycles: function (patientId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPatientCycles(patientId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, globalAxios, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} partnerName
         * @param {string} [q]
         * @param {FlowStatuses} [flowStatus]
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatients: function (partnerName, q, flowStatus, page, perPage, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPatients(partnerName, q, flowStatus, page, perPage, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, globalAxios, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Returns a list of related patients
         * @summary Get the list of related patients
         * @param {string} patientId The patient uuid
         * @param {number} [page] the page to get
         * @param {number} [perPage] the number of entries per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedPatients: function (patientId, page, perPage, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRelatedPatients(patientId, page, perPage, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, globalAxios, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Opt out the patient
         * @summary Opt out patient from service
         * @param {string} patientId The patient uuid
         * @param {OptOutPatientRequest} optOutPatientRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optOutPatient: function (patientId, optOutPatientRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.optOutPatient(patientId, optOutPatientRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, globalAxios, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * schedule call to the patient with params
         * @summary schedule a call to patient
         * @param {string} patientId The patient uuid
         * @param {ScheduleCallRequest} scheduleCallRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleCall: function (patientId, scheduleCallRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.scheduleCall(patientId, scheduleCallRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, globalAxios, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} outreachType
         * @param {string} partnerName
         * @param {File} file
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendBulkCommunications: function (outreachType, partnerName, file, type, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.sendBulkCommunications(outreachType, partnerName, file, type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, globalAxios, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Send a kit to the patient
         * @summary Send a kit to the patient
         * @param {string} patientId The patient uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendKit: function (patientId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.sendKit(patientId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, globalAxios, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * send sms to the patient by sms type
         * @summary Send sms to patient
         * @param {string} patientId The patient uuid
         * @param {SendSmsRequest} sendSmsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSms: function (patientId, sendSmsRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.sendSms(patientId, sendSmsRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, globalAxios, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} patientId
         * @param {UpdatePatientConsentRequestDto} updatePatientConsentRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPatientConsents: function (patientId, updatePatientConsentRequestDto, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.setPatientConsents(patientId, updatePatientConsentRequestDto, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, globalAxios, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {string} patientId
         * @param {PatientCallRequestBody} patientCallRequestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startCall: function (patientId, patientCallRequestBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.startCall(patientId, patientCallRequestBody, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, globalAxios, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * update patient
         * @summary Update a patient
         * @param {string} patientId The patient uuid
         * @param {UpdatePatientRequest} updatePatientRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatient: function (patientId, updatePatientRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updatePatient(patientId, updatePatientRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, globalAxios, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Update pcp details
         * @summary Update the details for a patient\'s pcp
         * @param {string} patientId The patient uuid
         * @param {UpdatePcpDetailsRequest} updatePcpDetailsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePcpDetails: function (patientId, updatePcpDetailsRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updatePcpDetails(patientId, updatePcpDetailsRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, globalAxios, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.PatientsApiFp = PatientsApiFp;
/**
 * PatientsApi - factory interface
 * @export
 */
var PatientsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PatientsApiFp)(configuration);
    return {
        /**
         *
         * @param {string} patientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        abortPostTestFlow: function (patientId, options) {
            return localVarFp.abortPostTestFlow(patientId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {CreatePatientRequestBody} createPatientRequestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatient: function (createPatientRequestBody, options) {
            return localVarFp.createPatient(createPatientRequestBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create a patient note
         * @summary Create a patient note
         * @param {string} patientId The patient uuid
         * @param {CreatePatientNoteRequest} createPatientNoteRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPatientNote: function (patientId, createPatientNoteRequest, options) {
            return localVarFp.createPatientNote(patientId, createPatientNoteRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete tasks from scheduler and communications from behealthy and outreach
         * @summary Delete patients tasks and communications
         * @param {string} partnerName The partner name of the patients
         * @param {'sendKit' | 'scheduleCall' | 'sendSms' | 'sendEmail' | 'sendLetter' | 'sendPrioritizedOutreach' | 'endPatientService' | 'startPatientEndOfServiceCommunication' | 'startPatientEndOfFollowUpServiceCommunication'} method The event name of the task to delete
         * @param {string} [entityIds] The patient ids. Exactly one of the field must be given [cohortId, entityIds]
         * @param {string} [cohortId] The cohort id of the patients. Exactly one of the field must be given [cohortId, entityIds]
         * @param {string} [type] The type of the communication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePatientsTasks: function (partnerName, method, entityIds, cohortId, type, options) {
            return localVarFp.deletePatientsTasks(partnerName, method, entityIds, cohortId, type, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get patient details
         * @summary Get patient details
         * @param {string} patientId The patient uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatient: function (patientId, options) {
            return localVarFp.getPatient(patientId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} patientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatientCycles: function (patientId, options) {
            return localVarFp.getPatientCycles(patientId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} partnerName
         * @param {string} [q]
         * @param {FlowStatuses} [flowStatus]
         * @param {number} [page]
         * @param {number} [perPage]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPatients: function (partnerName, q, flowStatus, page, perPage, options) {
            return localVarFp.getPatients(partnerName, q, flowStatus, page, perPage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a list of related patients
         * @summary Get the list of related patients
         * @param {string} patientId The patient uuid
         * @param {number} [page] the page to get
         * @param {number} [perPage] the number of entries per page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedPatients: function (patientId, page, perPage, options) {
            return localVarFp.getRelatedPatients(patientId, page, perPage, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Opt out the patient
         * @summary Opt out patient from service
         * @param {string} patientId The patient uuid
         * @param {OptOutPatientRequest} optOutPatientRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optOutPatient: function (patientId, optOutPatientRequest, options) {
            return localVarFp.optOutPatient(patientId, optOutPatientRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * schedule call to the patient with params
         * @summary schedule a call to patient
         * @param {string} patientId The patient uuid
         * @param {ScheduleCallRequest} scheduleCallRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleCall: function (patientId, scheduleCallRequest, options) {
            return localVarFp.scheduleCall(patientId, scheduleCallRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} outreachType
         * @param {string} partnerName
         * @param {File} file
         * @param {string} [type]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendBulkCommunications: function (outreachType, partnerName, file, type, options) {
            return localVarFp.sendBulkCommunications(outreachType, partnerName, file, type, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Send a kit to the patient
         * @summary Send a kit to the patient
         * @param {string} patientId The patient uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendKit: function (patientId, options) {
            return localVarFp.sendKit(patientId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * send sms to the patient by sms type
         * @summary Send sms to patient
         * @param {string} patientId The patient uuid
         * @param {SendSmsRequest} sendSmsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSms: function (patientId, sendSmsRequest, options) {
            return localVarFp.sendSms(patientId, sendSmsRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} patientId
         * @param {UpdatePatientConsentRequestDto} updatePatientConsentRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPatientConsents: function (patientId, updatePatientConsentRequestDto, options) {
            return localVarFp.setPatientConsents(patientId, updatePatientConsentRequestDto, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {string} patientId
         * @param {PatientCallRequestBody} patientCallRequestBody
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startCall: function (patientId, patientCallRequestBody, options) {
            return localVarFp.startCall(patientId, patientCallRequestBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * update patient
         * @summary Update a patient
         * @param {string} patientId The patient uuid
         * @param {UpdatePatientRequest} updatePatientRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePatient: function (patientId, updatePatientRequest, options) {
            return localVarFp.updatePatient(patientId, updatePatientRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update pcp details
         * @summary Update the details for a patient\'s pcp
         * @param {string} patientId The patient uuid
         * @param {UpdatePcpDetailsRequest} updatePcpDetailsRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePcpDetails: function (patientId, updatePcpDetailsRequest, options) {
            return localVarFp.updatePcpDetails(patientId, updatePcpDetailsRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PatientsApiFactory = PatientsApiFactory;
/**
 * PatientsApi - object-oriented interface
 * @export
 * @class PatientsApi
 * @extends {BaseAPI}
 */
var PatientsApi = /** @class */ (function (_super) {
    __extends(PatientsApi, _super);
    function PatientsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} patientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    PatientsApi.prototype.abortPostTestFlow = function (patientId, options) {
        var _this = this;
        return (0, exports.PatientsApiFp)(this.configuration).abortPostTestFlow(patientId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {CreatePatientRequestBody} createPatientRequestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    PatientsApi.prototype.createPatient = function (createPatientRequestBody, options) {
        var _this = this;
        return (0, exports.PatientsApiFp)(this.configuration).createPatient(createPatientRequestBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create a patient note
     * @summary Create a patient note
     * @param {string} patientId The patient uuid
     * @param {CreatePatientNoteRequest} createPatientNoteRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    PatientsApi.prototype.createPatientNote = function (patientId, createPatientNoteRequest, options) {
        var _this = this;
        return (0, exports.PatientsApiFp)(this.configuration).createPatientNote(patientId, createPatientNoteRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete tasks from scheduler and communications from behealthy and outreach
     * @summary Delete patients tasks and communications
     * @param {string} partnerName The partner name of the patients
     * @param {'sendKit' | 'scheduleCall' | 'sendSms' | 'sendEmail' | 'sendLetter' | 'sendPrioritizedOutreach' | 'endPatientService' | 'startPatientEndOfServiceCommunication' | 'startPatientEndOfFollowUpServiceCommunication'} method The event name of the task to delete
     * @param {string} [entityIds] The patient ids. Exactly one of the field must be given [cohortId, entityIds]
     * @param {string} [cohortId] The cohort id of the patients. Exactly one of the field must be given [cohortId, entityIds]
     * @param {string} [type] The type of the communication
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    PatientsApi.prototype.deletePatientsTasks = function (partnerName, method, entityIds, cohortId, type, options) {
        var _this = this;
        return (0, exports.PatientsApiFp)(this.configuration).deletePatientsTasks(partnerName, method, entityIds, cohortId, type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get patient details
     * @summary Get patient details
     * @param {string} patientId The patient uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    PatientsApi.prototype.getPatient = function (patientId, options) {
        var _this = this;
        return (0, exports.PatientsApiFp)(this.configuration).getPatient(patientId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} patientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    PatientsApi.prototype.getPatientCycles = function (patientId, options) {
        var _this = this;
        return (0, exports.PatientsApiFp)(this.configuration).getPatientCycles(patientId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} partnerName
     * @param {string} [q]
     * @param {FlowStatuses} [flowStatus]
     * @param {number} [page]
     * @param {number} [perPage]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    PatientsApi.prototype.getPatients = function (partnerName, q, flowStatus, page, perPage, options) {
        var _this = this;
        return (0, exports.PatientsApiFp)(this.configuration).getPatients(partnerName, q, flowStatus, page, perPage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a list of related patients
     * @summary Get the list of related patients
     * @param {string} patientId The patient uuid
     * @param {number} [page] the page to get
     * @param {number} [perPage] the number of entries per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    PatientsApi.prototype.getRelatedPatients = function (patientId, page, perPage, options) {
        var _this = this;
        return (0, exports.PatientsApiFp)(this.configuration).getRelatedPatients(patientId, page, perPage, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Opt out the patient
     * @summary Opt out patient from service
     * @param {string} patientId The patient uuid
     * @param {OptOutPatientRequest} optOutPatientRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    PatientsApi.prototype.optOutPatient = function (patientId, optOutPatientRequest, options) {
        var _this = this;
        return (0, exports.PatientsApiFp)(this.configuration).optOutPatient(patientId, optOutPatientRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * schedule call to the patient with params
     * @summary schedule a call to patient
     * @param {string} patientId The patient uuid
     * @param {ScheduleCallRequest} scheduleCallRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    PatientsApi.prototype.scheduleCall = function (patientId, scheduleCallRequest, options) {
        var _this = this;
        return (0, exports.PatientsApiFp)(this.configuration).scheduleCall(patientId, scheduleCallRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} outreachType
     * @param {string} partnerName
     * @param {File} file
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    PatientsApi.prototype.sendBulkCommunications = function (outreachType, partnerName, file, type, options) {
        var _this = this;
        return (0, exports.PatientsApiFp)(this.configuration).sendBulkCommunications(outreachType, partnerName, file, type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Send a kit to the patient
     * @summary Send a kit to the patient
     * @param {string} patientId The patient uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    PatientsApi.prototype.sendKit = function (patientId, options) {
        var _this = this;
        return (0, exports.PatientsApiFp)(this.configuration).sendKit(patientId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * send sms to the patient by sms type
     * @summary Send sms to patient
     * @param {string} patientId The patient uuid
     * @param {SendSmsRequest} sendSmsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    PatientsApi.prototype.sendSms = function (patientId, sendSmsRequest, options) {
        var _this = this;
        return (0, exports.PatientsApiFp)(this.configuration).sendSms(patientId, sendSmsRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} patientId
     * @param {UpdatePatientConsentRequestDto} updatePatientConsentRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    PatientsApi.prototype.setPatientConsents = function (patientId, updatePatientConsentRequestDto, options) {
        var _this = this;
        return (0, exports.PatientsApiFp)(this.configuration).setPatientConsents(patientId, updatePatientConsentRequestDto, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {string} patientId
     * @param {PatientCallRequestBody} patientCallRequestBody
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    PatientsApi.prototype.startCall = function (patientId, patientCallRequestBody, options) {
        var _this = this;
        return (0, exports.PatientsApiFp)(this.configuration).startCall(patientId, patientCallRequestBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * update patient
     * @summary Update a patient
     * @param {string} patientId The patient uuid
     * @param {UpdatePatientRequest} updatePatientRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    PatientsApi.prototype.updatePatient = function (patientId, updatePatientRequest, options) {
        var _this = this;
        return (0, exports.PatientsApiFp)(this.configuration).updatePatient(patientId, updatePatientRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update pcp details
     * @summary Update the details for a patient\'s pcp
     * @param {string} patientId The patient uuid
     * @param {UpdatePcpDetailsRequest} updatePcpDetailsRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PatientsApi
     */
    PatientsApi.prototype.updatePcpDetails = function (patientId, updatePcpDetailsRequest, options) {
        var _this = this;
        return (0, exports.PatientsApiFp)(this.configuration).updatePcpDetails(patientId, updatePcpDetailsRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PatientsApi;
}(base_1.BaseAPI));
exports.PatientsApi = PatientsApi;
/**
 * PcpsApi - axios parameter creator
 * @export
 */
var PcpsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get all the pcps
         * @summary Get pcps
         * @param {string} partnerName The partner name
         * @param {number} page The requested page
         * @param {number} perPage The amount of patients to show per page
         * @param {'patient'} [include] The properties that should be included in the response
         * @param {'unconfirmed'} [confirmationStatus] The confirmation status
         * @param {string} [q] Free text to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPcps: function (partnerName, page, perPage, include, confirmationStatus, q, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'partnerName' is not null or undefined
                            (0, common_1.assertParamExists)('getPcps', 'partnerName', partnerName);
                            // verify required parameter 'page' is not null or undefined
                            (0, common_1.assertParamExists)('getPcps', 'page', page);
                            // verify required parameter 'perPage' is not null or undefined
                            (0, common_1.assertParamExists)('getPcps', 'perPage', perPage);
                            localVarPath = "/pcps";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication umAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication umAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (include !== undefined) {
                                localVarQueryParameter['include'] = include;
                            }
                            if (partnerName !== undefined) {
                                localVarQueryParameter['partnerName'] = partnerName;
                            }
                            if (confirmationStatus !== undefined) {
                                localVarQueryParameter['confirmationStatus'] = confirmationStatus;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (perPage !== undefined) {
                                localVarQueryParameter['perPage'] = perPage;
                            }
                            if (q !== undefined) {
                                localVarQueryParameter['q'] = q;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.PcpsApiAxiosParamCreator = PcpsApiAxiosParamCreator;
/**
 * PcpsApi - functional programming interface
 * @export
 */
var PcpsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.PcpsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get all the pcps
         * @summary Get pcps
         * @param {string} partnerName The partner name
         * @param {number} page The requested page
         * @param {number} perPage The amount of patients to show per page
         * @param {'patient'} [include] The properties that should be included in the response
         * @param {'unconfirmed'} [confirmationStatus] The confirmation status
         * @param {string} [q] Free text to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPcps: function (partnerName, page, perPage, include, confirmationStatus, q, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPcps(partnerName, page, perPage, include, confirmationStatus, q, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, globalAxios, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.PcpsApiFp = PcpsApiFp;
/**
 * PcpsApi - factory interface
 * @export
 */
var PcpsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.PcpsApiFp)(configuration);
    return {
        /**
         * Get all the pcps
         * @summary Get pcps
         * @param {string} partnerName The partner name
         * @param {number} page The requested page
         * @param {number} perPage The amount of patients to show per page
         * @param {'patient'} [include] The properties that should be included in the response
         * @param {'unconfirmed'} [confirmationStatus] The confirmation status
         * @param {string} [q] Free text to search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPcps: function (partnerName, page, perPage, include, confirmationStatus, q, options) {
            return localVarFp.getPcps(partnerName, page, perPage, include, confirmationStatus, q, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.PcpsApiFactory = PcpsApiFactory;
/**
 * PcpsApi - object-oriented interface
 * @export
 * @class PcpsApi
 * @extends {BaseAPI}
 */
var PcpsApi = /** @class */ (function (_super) {
    __extends(PcpsApi, _super);
    function PcpsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get all the pcps
     * @summary Get pcps
     * @param {string} partnerName The partner name
     * @param {number} page The requested page
     * @param {number} perPage The amount of patients to show per page
     * @param {'patient'} [include] The properties that should be included in the response
     * @param {'unconfirmed'} [confirmationStatus] The confirmation status
     * @param {string} [q] Free text to search
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PcpsApi
     */
    PcpsApi.prototype.getPcps = function (partnerName, page, perPage, include, confirmationStatus, q, options) {
        var _this = this;
        return (0, exports.PcpsApiFp)(this.configuration).getPcps(partnerName, page, perPage, include, confirmationStatus, q, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return PcpsApi;
}(base_1.BaseAPI));
exports.PcpsApi = PcpsApi;
/**
 * SendResultsApi - axios parameter creator
 * @export
 */
var SendResultsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Returns the data needed to resend results for a patient.
         * @param {string} patientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRequests: function (patientId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'patientId' is not null or undefined
                            (0, common_1.assertParamExists)('getRequests', 'patientId', patientId);
                            localVarPath = "/send-results-requests/{patientId}"
                                .replace("{".concat("patientId", "}"), encodeURIComponent(String(patientId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication umAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication umAuth required
                            // http bearer authentication required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Resend the results for a particular orderId and flow.
         * @param {string} patientId
         * @param {ResendRequest} resendRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendResults: function (patientId, resendRequest, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'patientId' is not null or undefined
                            (0, common_1.assertParamExists)('resendResults', 'patientId', patientId);
                            // verify required parameter 'resendRequest' is not null or undefined
                            (0, common_1.assertParamExists)('resendResults', 'resendRequest', resendRequest);
                            localVarPath = "/send-results-requests/{patientId}/resend"
                                .replace("{".concat("patientId", "}"), encodeURIComponent(String(patientId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication umAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication umAuth required
                            // http bearer authentication required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = resendRequest;
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.SendResultsApiAxiosParamCreator = SendResultsApiAxiosParamCreator;
/**
 * SendResultsApi - functional programming interface
 * @export
 */
var SendResultsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SendResultsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Returns the data needed to resend results for a patient.
         * @param {string} patientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRequests: function (patientId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRequests(patientId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, globalAxios, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         * Resend the results for a particular orderId and flow.
         * @param {string} patientId
         * @param {ResendRequest} resendRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendResults: function (patientId, resendRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.resendResults(patientId, resendRequest, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, globalAxios, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.SendResultsApiFp = SendResultsApiFp;
/**
 * SendResultsApi - factory interface
 * @export
 */
var SendResultsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SendResultsApiFp)(configuration);
    return {
        /**
         * Returns the data needed to resend results for a patient.
         * @param {string} patientId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRequests: function (patientId, options) {
            return localVarFp.getRequests(patientId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Resend the results for a particular orderId and flow.
         * @param {string} patientId
         * @param {ResendRequest} resendRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendResults: function (patientId, resendRequest, options) {
            return localVarFp.resendResults(patientId, resendRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SendResultsApiFactory = SendResultsApiFactory;
/**
 * SendResultsApi - object-oriented interface
 * @export
 * @class SendResultsApi
 * @extends {BaseAPI}
 */
var SendResultsApi = /** @class */ (function (_super) {
    __extends(SendResultsApi, _super);
    function SendResultsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns the data needed to resend results for a patient.
     * @param {string} patientId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SendResultsApi
     */
    SendResultsApi.prototype.getRequests = function (patientId, options) {
        var _this = this;
        return (0, exports.SendResultsApiFp)(this.configuration).getRequests(patientId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Resend the results for a particular orderId and flow.
     * @param {string} patientId
     * @param {ResendRequest} resendRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SendResultsApi
     */
    SendResultsApi.prototype.resendResults = function (patientId, resendRequest, options) {
        var _this = this;
        return (0, exports.SendResultsApiFp)(this.configuration).resendResults(patientId, resendRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SendResultsApi;
}(base_1.BaseAPI));
exports.SendResultsApi = SendResultsApi;
/**
 * TagsApi - axios parameter creator
 * @export
 */
var TagsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get all tags filtered by partner tag type
         * @summary Get a list of all tags
         * @param {'partner' | 'orgUnit'} [type] The partner tags type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTags: function (type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/tags";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication umAuth required
                            // http bearer authentication required
                            return [4 /*yield*/, (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration)];
                        case 1:
                            // authentication umAuth required
                            // http bearer authentication required
                            _a.sent();
                            if (type !== undefined) {
                                localVarQueryParameter['type'] = type;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.TagsApiAxiosParamCreator = TagsApiAxiosParamCreator;
/**
 * TagsApi - functional programming interface
 * @export
 */
var TagsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.TagsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get all tags filtered by partner tag type
         * @summary Get a list of all tags
         * @param {'partner' | 'orgUnit'} [type] The partner tags type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTags: function (type, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getTags(type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, globalAxios, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.TagsApiFp = TagsApiFp;
/**
 * TagsApi - factory interface
 * @export
 */
var TagsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.TagsApiFp)(configuration);
    return {
        /**
         * Get all tags filtered by partner tag type
         * @summary Get a list of all tags
         * @param {'partner' | 'orgUnit'} [type] The partner tags type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTags: function (type, options) {
            return localVarFp.getTags(type, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.TagsApiFactory = TagsApiFactory;
/**
 * TagsApi - object-oriented interface
 * @export
 * @class TagsApi
 * @extends {BaseAPI}
 */
var TagsApi = /** @class */ (function (_super) {
    __extends(TagsApi, _super);
    function TagsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get all tags filtered by partner tag type
     * @summary Get a list of all tags
     * @param {'partner' | 'orgUnit'} [type] The partner tags type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagsApi
     */
    TagsApi.prototype.getTags = function (type, options) {
        var _this = this;
        return (0, exports.TagsApiFp)(this.configuration).getTags(type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return TagsApi;
}(base_1.BaseAPI));
exports.TagsApi = TagsApi;
